/** localStorage key: active team for API `X-Team-Id` (team member / owner workspace). */
export const MA_ACTIVE_TEAM_ID_KEY = 'ma_active_team_id';
